var parseTimeRanges = function (ranges) {
    var result = [];
    for (var i = 0; i < ranges.length; i++) {
        result.push({
            start: ranges.start(i),
            end: ranges.end(i),
        });
    }
    return result;
};
export default parseTimeRanges;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/util/parseTimeRanges.js
// module id = ./node_modules/react-use/esm/util/parseTimeRanges.js
// module chunks = main